type BadgeProps={
    value: number
}
export function Badge({value}:BadgeProps){
    if(!(value>0))return;
    return(
        <span className={"ais-badge"}>{value}</span>
    )
}